import React, { Component } from 'react';
import { FormSection } from '@eg/elements/FormSection';
import { InputRow } from '@eg/elements/InputRow';
import { SelectRow } from '@eg/elements/SelectRow';
import { FormRow } from '@eg/elements/FormRow';
import { Input } from '@eg/elements/Input';
import { FormFooter } from '@eg/elements/FormFooter';
import { Button } from '@eg/elements/Button';
import { Checkbox } from '@eg/elements/Checkbox';
import { DateInput } from '@eg/elements/DateInput';
import { ArrowRightIcon } from '@eg/elements/Icons/ArrowRightIcon';

import CheckoutNavigation from '../../../components/shared/checkout-navigation/CheckoutNavigation';
import PrivacyInformation from '../../../components/shared/privacy-information/PrivacyInformation';
import FirstInformation from '../../../components/shared/first-information/FirstInformation';

import { clearSessionStorage } from '../../common/SessionHandler';

import "./OrderForm.scss";

import axios from 'axios';

class OrderForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nonce: '',
      salutation: '',
      firstName: '',
      lastName: '',
      street: '',
      houseNumber: '',
      zip: '',
      city: '',
      dateOfBirth: '',
      email: '',
      compEmail: '',
      phoneNumber: '',
      acceptEweMail: false,
      acceptEwePhone: false,
      startDateForPolicy: new Date(sessionStorage.getItem('insuranceStartDate')),
      advertiserID: '',

      validations: {
        salutationInvalid: false,
        firstNameInvalid: false,
        lastNameInvalid: false,
        streetInvalid: false,
        houseNumberInvalid: false,
        zipInvalid: false,
        cityInvalid: false,
        birthdayInvalid: false,
        emailInvalid: false,
        emailCompInvalid: false,
        emailNotEquals: false,
        phoneNumberInvalid: false
      },

      submitDisabled: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.getBirthdayInput = this.getBirthdayInput.bind(this);
  }

  componentDidMount() {
    if(sessionStorage.getItem('insuranceStartDate') === null || !this.checkTimer()) {
      clearSessionStorage();
      this.props.history.push("/internet-schutzbrief/tarifdaten");
      return;
    } else if (sessionStorage.getItem('paymentId') != null) {
      axios.get(process.env.REACT_APP_BACKEND_URL + '/csppayments/' + sessionStorage.getItem('paymentId')).then((res) => {

        this.setState({
          salutation: res.data.salutation,
          firstName: res.data.firstName,
          lastName: res.data.lastName,
          street: res.data.street,
          houseNumber: res.data.houseNumber,
          zip: res.data.zip,
          city: res.data.city,
          dateOfBirth: res.data.dateOfBirth,
          email: res.data.email,
          compEmail: res.data.email,
          phoneNumber: res.data.phoneNumber,
          acceptEweMail: res.data.acceptEweMail,
          acceptEwePhone: res.data.acceptEwePhone,
          advertiserID: res.data.advertiserID,
        });

        if(this.state.advertiserID !== this.getUrlData('ANR') && this.getUrlData('ANR') !== undefined) {
          this.setState({advertiserID : this.getUrlData('ANR')});
        }

        if(res.data.advertiserID !== null && res.data.advertiserID !== undefined && res.data.advertiserID !== '') {
          this.props.history.push("/internet-schutzbrief/persoenliches?ANR=" + this.state.advertiserID);
        }
      }).catch((error) => {
        this.errorHandler(error);
      });

      axios.post(process.env.REACT_APP_BACKEND_URL + '/nonce', {'nonceType': 'UPDATE'}).then((res) => {
        this.setState({nonce: res.data.nonce});
      }).catch((error) => {
        this.errorHandler(error);
      });
    } else {
      axios.post(process.env.REACT_APP_BACKEND_URL + '/nonce', {'nonceType': 'CREATE'}).then((res) => {
        this.setState({nonce: res.data.nonce});
      }).catch((error) => {
        this.errorHandler(error);
      });
    }
  }

  getUrlData = (variable) => {
    var url = window.location.search.substring(1);
    var data = url.split("?");

    for (var i=0; i<data.length; i++) {
      var pair = data[i].split("=");
      if(pair[0] === variable) {
        return pair[1];
      }
    }
  }

  checkTimer = () => {
    var now = new Date();
    var start = new Date (sessionStorage.getItem('timestamp'));
    var diff =(now.getTime() - start.getTime()) / 1000;
    var res;

    diff /= 60;
    res = Math.abs(Math.round(diff));

    return (res < 30);
  }

  formIsValid = () => {
    var validations = this.state.validations;
    validations['salutationInvalid'] = !this.validateSalutation(this.state.salutation);
    validations['firstNameInvalid'] = !this.validateInput(this.state.firstName);
    validations['lastNameInvalid'] = !this.validateInput(this.state.lastName);
    validations['streetInvalid'] = !this.validateInput(this.state.street);
    validations['houseNumberInvalid'] = !this.validateInput(this.state.houseNumber);
    validations['zipInvalid'] = !this.validateZip();
    validations['cityInvalid'] = !this.validateInput(this.state.city);
    validations['birthdayInvalid'] = !this.validateBirthday();
    validations['emailInvalid'] = !this.validateEmail(this.state.email);
    validations['emailCompInvalid'] = !this.validateEmail(this.state.compEmail);
    validations['emailNotEquals'] = !this.validateEmails();
    validations['phoneNumberInvalid'] = !this.validatePhoneNumber();

    this.setState({ validations: validations});

    for (let value of Object.values(validations)) {
      if(value === true) {
        return false;
      }
    }

    return true;
  }

  validateSalutation = (salutation) => {
    if(salutation === undefined || salutation === null) {
      return false;
    }

    if(salutation !== 'Frau' && salutation !== 'Herr') {
      return false;
    }

    return true;
  }

  validateInput = (input) => {
    var re = /^[^<>!"§$%&\\/+*#()=?{}~°_;^]+$/;
    return re.test(input);
  }

  validateZip = () => {
    var re = /^\d{5}$/;
    return re.test(this.state.zip);
  }

  validateBirthday = () => {
    var dateOfBirthString = this.putBirthdayInFormat(this.state.dateOfBirth);
    if(dateOfBirthString === undefined || dateOfBirthString === null || dateOfBirthString === '') {
      return false;
    }

    var dateOfBirth = new Date(dateOfBirthString);

    // Invalid date, i.e. missing month
    if(isNaN(dateOfBirth.getTime())) {
      return false;
    }

    var today = new Date();
    var minBirthDate = new Date();
    minBirthDate.setYear(today.getFullYear() - 18);
    minBirthDate.setDate(today.getDate() + 1);
    minBirthDate.setHours(0,0,0,0);

    if(dateOfBirth < minBirthDate) {
      return true;
    }

    return false;
  }

  validateEmail = (input) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(input);
  }

  validateEmails = () => {
    if(this.state.email === this.state.compEmail) {
      return true;
    }

    return false;
  }

  validatePhoneNumber = () => {
    var phoneNumber = this.state.phoneNumber;

    if(phoneNumber === undefined || phoneNumber === null || phoneNumber === '') {
      return true;
    } else {
      return this.validateInput(this.state.phoneNumber);
    }
  }

  handleSubmit = () => {
    this.setState({submitDisabled: true});

    var formIsValid = this.formIsValid();

    if(formIsValid && sessionStorage.getItem('paymentId') === null) {
      axios.post(process.env.REACT_APP_BACKEND_URL + '/csppayments', this.createFormData()).then((res) => {
        sessionStorage.setItem('approvalUrl', res.data.approvalUrl);
        sessionStorage.setItem('paymentId', res.data.paymentId)
        sessionStorage.setItem('mode', res.data.mode);

        this.setState({submitDisabled: false});
        this.props.history.push("/internet-schutzbrief/bezahlmethode");

        window.scrollTo(0, 0);
      }).catch((error) => {
        this.errorHandler(error);
      });
    } else if(formIsValid && sessionStorage.getItem('paymentId') != null) {
      axios.put(process.env.REACT_APP_BACKEND_URL + '/csppayments/' + sessionStorage.getItem('paymentId'), this.createFormData()).then((res) =>{
        sessionStorage.setItem('approvalUrl', res.data.approvalUrl);
        sessionStorage.setItem('paymentId', res.data.paymentId)
        sessionStorage.setItem('mode', res.data.mode);

        this.setState({submitDisabled: false});
        this.props.history.push("/internet-schutzbrief/bezahlmethode");

        window.scrollTo(0, 0);
      }).catch((error) => {
        this.errorHandler(error);
        window.scrollTo(0, 0);
      });
    } else {
      this.setState({submitDisabled: false});
    }
  }

  createFormData = () => {
    var urlANR = this.getUrlData('ANR');

    if(!this.state.advertiserID !== urlANR) {
      this.setState({advertiserID : urlANR});
    } else {
      urlANR = this.state.advertiserID;
    }

    return {
      'nonce': this.state.nonce,
      'salutation': this.state.salutation,
      'firstName': this.state.firstName,
      'lastName': this.state.lastName,
      'street': this.state.street,
      'houseNumber': this.state.houseNumber,
      'zip': parseInt(this.state.zip, 10),
      'city': this.state.city,
      'dateOfBirth': this.putBirthdayInFormat(),
      'email': this.state.email,
      'phoneNumber': this.state.phoneNumber,
      'acceptEweMail': this.state.acceptEweMail,
      'acceptEwePhone': this.state.acceptEwePhone,
      'startDateForPolicy': this.formatDateForRequest(this.state.startDateForPolicy),
      'advertiserID': urlANR,
    };
  }

  errorHandler = (error) => {
    if(error === null || error === undefined || error.response === null || error.response === undefined) {
      clearSessionStorage();
      this.props.history.push("/internet-schutzbrief/404");
    } else if(error.response.status === 400 ) {
      clearSessionStorage();
      this.props.history.push("/internet-schutzbrief/technischer-fehler");
    } else if (error.response.status === 404) {
      clearSessionStorage();
      this.props.history.push("/internet-schutzbrief/404");
    } else if (error.response.status === 406) {
      // TODO
      this.setState({submitDisabled: false});
    } else if (error.response.status === 403) {
      this.props.history.push("/internet-schutzbrief/403");
    } else {
      clearSessionStorage();
      this.props.history.push("/internet-schutzbrief/technischer-fehler");
    }
  }

  formatDateForRequest = (dateObject) => {
    var month = dateObject.getMonth()+1;
    var day = dateObject.getDate();

    if(month < 10) {
      month = '0' + month;
    }

    if(day < 10) {
      day = '0' + day;
    }

    return dateObject.getFullYear() + '-' + month + '-' + day;
  }

  handleChange(e) {
    const name = e.target.name;
    const value = e.target.value;

    this.setState({ [name]: value });
  }

  putBirthdayInFormat = () => {
    if(this.getBirthdayInput()) {
      var birthdayArray = this.getBirthdayInput();
      var month = birthdayArray.month;
      var day = birthdayArray.day;

      if(birthdayArray.month < 10 && birthdayArray.month.length < 2){
        month = '0' + birthdayArray.month;
      }

      if(birthdayArray.day < 10 && birthdayArray.day.length < 2){
        day ='0' + birthdayArray.day;
      }

      return (birthdayArray.year + "-" + month + "-" + day);
    }
  }

  handleChangeBirthday = (birthday) => {
    this.setState({dateOfBirth: birthday.year + '-' + birthday.month + '-' + birthday.day});
  }

  getBirthdayInput() {
    var birthdayString = this.state.dateOfBirth;
    var birthdayArray = birthdayString.split('-');
    return({day: birthdayArray[2], month: birthdayArray[1], year: birthdayArray[0]})
  }

  render() {
    const birthdayObj = this.getBirthdayInput();
    return(
      <div className="esc_container outerContainer" id="order-form">
        <div className="esc_container esc_container--l">
          <CheckoutNavigation step="1" />
          <PrivacyInformation />
          <div className="OrderForm">
            <form onSubmit={this.handleSubmit}>
              <FormSection id="form" heading="Persönliche Daten des Versicherungsnehmers">
                <input type="hidden" id="x-csrf-token" name="x-csrf-token" value={this.state.nonce} />
                <p></p>
                <SelectRow label="Anrede *" name="salutation" value={this.state.salutation} onChange={this.handleChange} error={this.state.validations.salutationInvalid} >
                  <option value="">Anrede *</option>
                  <option value="Frau">Frau</option>
                  <option value="Herr">Herr</option>
                </SelectRow>
                <InputRow name="firstName" placeholder="Vorname *" label="Vorname *" value={this.state.firstName}  onChange={this.handleChange} error={this.state.validations.firstNameInvalid} />
                <InputRow name="lastName" placeholder="Nachname *" label="Nachname *" value={this.state.lastName} onChange={this.handleChange} error={this.state.validations.lastNameInvalid} />
                <FormRow label="Straße und Hausnummer *"  colspans={[3,1]}>
                  <Input name="street" placeholder="Straße *" aria-label="Street" value={this.state.street} onChange={this.handleChange} error={this.state.validations.streetInvalid} />
                  <Input name="houseNumber" placeholder="Nr. *" aria-label="houseNumber" value={this.state.houseNumber} onChange={this.handleChange} error={this.state.validations.houseNumberInvalid}/>
                </FormRow>
                <FormRow label="PLZ und Ort *" colspans={[1,3]}>
                  <Input name="zip" type="text" pattern="[0-9]*"  placeholder="PLZ *" aria-label="zip" value={this.state.zip} onChange={this.handleChange} error={this.state.validations.zipInvalid} />
                  <Input name="city" placeholder="Ort *" aria-label="city" value={this.state.city} onChange={this.handleChange} error={this.state.validations.cityInvalid} />
                </FormRow>
                <FormRow label="Geburtsdatum*">
                  <DateInput id="birthdayInput" name="birthday" value={birthdayObj} onChange={this.handleChangeBirthday} error={this.state.validations.birthdayInvalid}/>
                </FormRow>
                <InputRow type="email" name="email" placeholder="E-Mail-Adresse *" label="E-Mail *" value={this.state.email} onChange={this.handleChange} error={this.state.validations.emailInvalid} />
                <InputRow placeholder="E-Mail-Adresse bestätigen *" label="E-Mail wiederholen *" name="compEmail" value={this.state.compEmail} onChange={this.handleChange} error={(this.state.validations.compEmailInvalid || this.state.validations.emailNotEquals)}/>
                <InputRow name="phoneNumber" placeholder="Telefonnummer" label="Telefonnummer" value={this.state.phoneNumber} onChange={this.handleChange} error={this.state.validations.phoneNumberInvalid} />
              </FormSection>
              <div id="checkboxCondition">
                <Checkbox
                  label="Ich willige ein, dass ich künftig per elektronischer Post über Versicherungs- und Finanzprodukte von Unternehmen und Vermittlern der ERGO Group** informiert werde . Sie können mich auch zur Kundenbefragung kontaktieren.
                  Meine Daten dürfen hierfür verarbeitet werden. Diese Einwilligung gilt unabhängig davon, ob ein Vertrag besteht. Ich kann sie jederzeit formlos für die Zukunft widerrufen."
                  name="acceptEweMail"
                  checked={this.state.acceptEweMail}
                  onChange={(e) => this.setState({ acceptEweMail: e.target.checked })}
                />
                <Checkbox
                  label="Ich willige ein, dass ich künftig per Telefon über Versicherungs- und Finanzprodukte von Unternehmen und Vermittlern der ERGO Group** informiert werde. Sie können mich auch zur Kundenbefragung kontaktieren.
                  Meine Daten dürfen hierfür verarbeitet werden. Diese Einwilligung gilt unabhängig davon, ob ein Vertrag besteht. Ich kann sie jederzeit formlos für die Zukunft widerrufen."
                  name="acceptEwePhone"
                  checked={this.state.acceptEwePhone}
                  onChange={(e) => this.setState({ acceptEwePhone: e.target.checked })}
                />
              </div>
              <FormFooter>
                * Pflichtfelder<br />
                ** ERGO Lebensversicherung AG, ERGO Versicherung AG, DKV Deutsche Krankenversicherung AG, ERGO Beratung und Vertrieb AG, ERGO Krankenversicherung AG, ERGO Direkt Lebensversicherung AG, ERGO Direkt Versicherung AG, ERGO Life S.A., ERGO Vorsorge Lebensversicherung AG, ERGO Reiseversicherung AG, ERGO Direkt AG <br />
              </FormFooter>
            </form>
            <FirstInformation />
            <Button variant="primary" onClick={this.handleSubmit} iconRight={ArrowRightIcon} size="auto" style={{ float: "right" }} loading={this.state.submitDisabled}>Weiter</Button>
          </div>
        </div>
      </div>
    );
  }
}

export default OrderForm;
